import pt from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import {
    DIALOG_PORTAL_CONTAINER_ID,
    isMobile,
    LegacyCommanderContextValue,
    unreliableIsMobileDevice,
    WithBreakpointRange,
} from '@mews-commander/ui';
import { formatDynamicDate, LocalizationSubscribeContext, WallClockDateService } from '@mews/framework';
import { MonthPicker, withBreakpointRange } from '@optimus-web/core';
import { getDateValue } from './selectors';

interface Props extends WithBreakpointRange {
    showMonthSelector?: boolean;
    error?: React.ReactNode;
}

type State = $TSFixMe;

class CommanderSingleDateStringPickerComponent extends Component<Props, State> {
    declare context: LegacyCommanderContextValue & LocalizationSubscribeContext;
    static contextTypes = {
        localizationSubscribe: pt.func.isRequired,
        getCalendarService: pt.func.isRequired,
    };

    unsubscribe: $TSFixMe;

    constructor(props: $TSFixMe, context: $TSFixMe) {
        super(props, context);
        // @ts-expect-error $TSFixMeError: Property 'value' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { value } = this.props;

        this.state = {
            value: value ? this.getValue(value) : null,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: $TSFixMe) {
        if (
            nextProps.value !== (this.props as $TSFixMe).value &&
            WallClockDateService.isValidString(
                nextProps.value,
                (this.props as $TSFixMe).currentDateTimeLocalizationInfo
            )
        ) {
            this.setState({
                value: this.getValue(nextProps.value),
            });
        }
    }

    componentDidMount() {
        this.unsubscribe = this.context.localizationSubscribe(() => this.forceUpdate());
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    getValue = (value: $TSFixMe) =>
        formatDynamicDate({
            value,
            currentDateTimeLocalizationInfo: (this.props as $TSFixMe).currentDateTimeLocalizationInfo,
        });

    handleChange = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent, value: $TSFixMe) => {
        // @ts-expect-error $TSFixMeError: Property 'currentDateTimeLocalizationInfo' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>...
        const { currentDateTimeLocalizationInfo } = this.props;

        if (value !== undefined && WallClockDateService.isValidString(value, currentDateTimeLocalizationInfo)) {
            this.setState({
                value: this.getValue(value),
            });
        }

        if ((this.props as $TSFixMe).onChange) {
            (this.props as $TSFixMe).onChange(value);
        }
    };

    render() {
        const { breakpointRange, ...other } = this.props;
        const isMobileDevice = isMobile(breakpointRange) || unreliableIsMobileDevice();
        const props = {
            ...other,
            getCalendarService: this.context.getCalendarService,
            portalContainerId: isMobileDevice ? DIALOG_PORTAL_CONTAINER_ID : undefined,
            autoComplete: 'off',
        };

        return <MonthPicker name="monthpicker" {...props} value={this.state.value} onChange={this.handleChange} />;
    }
}

export const SingleMonthStringPicker = connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        dateValue: getDateValue,
        currentDateTimeLocalizationInfo: getCurrentDateTimeLocalizationInfo,
    })
)(withBreakpointRange(CommanderSingleDateStringPickerComponent));
